"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _WeeklyTabs = _interopRequireDefault(require("../../WeeklyTabs/WeeklyTabs"));
var _Card = _interopRequireDefault(require("../../Card/Card"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // THIS NEEDS SOME LOVE
var FlexWeeklyLineups = exports["default"] = /*#__PURE__*/function (_Component) {
  function FlexWeeklyLineups() {
    var _this;
    (0, _classCallCheck2["default"])(this, FlexWeeklyLineups);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FlexWeeklyLineups, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", {
      weeks: {},
      loading: true
    });
    (0, _defineProperty2["default"])(_this, "changeWeek", function (updatedWeek) {
      var activeWeek = _this.state.activeWeek;
      activeWeek = updatedWeek;
      _this.setState({
        activeWeek: activeWeek
      });
    });
    return _this;
  }
  (0, _inherits2["default"])(FlexWeeklyLineups, _Component);
  return (0, _createClass2["default"])(FlexWeeklyLineups, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      fetch('/api/music/week-by-week', {
        method: 'GET',
        credentials: 'same-origin'
      }).then(function (response) {
        return response.json();
      }).then(function (response) {
        var weeks = Object.keys(response.data).map(function (weekNum) {
          return {
            destinations: (0, _toConsumableArray2["default"])(response.data[weekNum].map(function (destination) {
              return {
                title: destination.destination,
                subtitle: "".concat(destination.beginDate, " - ").concat(destination.endDate),
                value: '',
                link: {
                  url: destination.destinationSlug
                }
              };
            })),
            weekName: weekNum
          };
        });
        _this2.setState({
          weeks: weeks || {},
          loading: false
        });
      })["catch"](function (error) {
        _this2.setState({
          loading: false
        });
        console.warn('failed fetching user', error);
        return {
          status: 'failed',
          message: 'WRONG'
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        weeks = _this$state.weeks,
        loading = _this$state.loading;
      if (!loading) {
        return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
          className: "max-width-xxxs margin-auto"
        }, /*#__PURE__*/_react["default"].createElement(_WeeklyTabs["default"], {
          weeks: weeks
        }, function (_ref) {
          var activeWeek = _ref.activeWeek;
          return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
            template: "ListCard",
            items: weeks[activeWeek].destinations
          });
        })));
      }
      return null;
    }
  }]);
}(_react.Component);